import script from "./CreatePaper.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePaper.vue?vue&type=script&setup=true&lang=js"

import "./CreatePaper.vue?vue&type=style&index=0&id=eef5c22a&lang=scss"

const __exports__ = script;

export default __exports__